import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { colors } from "../../../utils/colors";

export const TOP_BAR_HEIGHT = 50;

const StrongLink = css`
    font-size: 14px;
    font-weight: 500;
    line-height: 1;
`;

export const Outer = styled.div``;

export const Inner = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: space-between;
    height: ${TOP_BAR_HEIGHT}px;
`;
export const Actions = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
`;

export const ActionItem = styled(Link)`
    color: white;
    display: flex;
    align-items: center;
    text-decoration: none;
    gap: 4px;
    ${StrongLink};

    &:hover {
        color: ${colors.brandLight};
    }
`;
